{
  "appCommit": "104d085751736ba68ab73bf6c9834a5ff9e90b66",
  "sourcePath": "packages/shared/src/legal-documents.ts",
  "sourceSha256": "a675b691f158f32ac4381a4875d4423ae037f5c1a23da1ac71ba5b1c5164087d",
  "document": {
    "kind": "dpa",
    "publicUrl": "https://scopeworth.app/dpa/1.3",
    "title": "Data Processing Agreement",
    "sha256": "822f1ba8e2bf4b25399f89e812ceed0dbdb4b2ad549719a7ea56dcd0393084c4",
    "version": "1.3",
    "effectiveAt": "2026-10-03T00:00:00.000Z",
    "status": "published",
    "files": [
      {
        "title": "Data Processing Agreement",
        "sha256": "46ae9936ae2b697ffb52009ccb0549ddf8e8dc39680ed39a5784784754cad43e",
        "path": "docs/legal/dpa/1.3/dpa.md"
      },
      {
        "title": "US State Privacy Addendum",
        "sha256": "b7ba74cb27d8854e5ad897741cc13b603b68d1ae84474c68c6a9f3c2b62f3c59",
        "path": "docs/legal/dpa/1.3/us-state-privacy-addendum.md"
      }
    ]
  }
}
